import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/common/Header/Header'; // Import your Header
import Footer from '../../components/common/Footer/Footer'; // Import Footer
import ContactForm from '../../components/common/ContactForm/ContactForm';
import heroImage from '../../assets/images/what-we-offer-heroimage.png';

const WhatWeOfferPage = () => {
  const navigate = useNavigate();

  const handleVisitFarms = () => {
    navigate('/ourfarm');
  };

  const styles = {
    pageContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    },
    
    // Hero section styles
    heroSection: {
      backgroundImage: `url(${heroImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      color: 'white',
    },
    heroContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      width: '100%',
    },
    heroContent: {
      maxWidth: '800px',
    },
    heroLabel: {
      color: 'rgba(255, 255, 255, 0.8)', 
      fontSize: '1.2rem', 
      marginBottom: '1rem', 
      textTransform: 'uppercase', 
      letterSpacing: '0.1em'
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      lineHeight: '1.1',
      marginBottom: '1.5rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.6',
      opacity: 0.95,
      maxWidth: '600px',
    },
    
    // Our Farms section
    ourFarmsSection: {
      padding: '5rem 0',
      backgroundColor: '#ffffff',
    },
    sectionContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
    },
    farmsGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 600px',
      gap: '4rem',
      alignItems: 'center',
    },
    farmsContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
    },
    sectionTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
    },
    sectionSubtitle: {
      fontSize: '2rem',
      color: '#b8860b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    farmsDescription: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#4a5568',
      marginBottom: '1.5rem',
    },
    visitButton: {
      backgroundColor: 'transparent',
      border: '2px solid #2d5016',
      color: '#2d5016',
      padding: '1rem 2rem',
      fontSize: '1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      borderRadius: '50px',
      cursor: 'pointer',
      width: 'fit-content',
      transition: 'all 0.3s ease',
    },
    farmsImage: {
      width: '100%',
      height: '400px',
      objectFit: 'cover',
      borderRadius: '12px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
    },
    
    // Green Impact section
    greenImpactSection: {
      padding: '5rem 0',
      backgroundColor: '#f8fafc',
    },
    impactGrid: {
      display: 'grid',
      gridTemplateColumns: '600px 1fr',
      gap: '4rem',
      alignItems: 'center',
    },
    impactImage: {
      width: '100%',
      height: '400px',
      objectFit: 'cover',
      borderRadius: '12px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
    },
    impactContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
    },
    impactDescription: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#4a5568',
      marginBottom: '1.5rem',
    },
    
    // Guarantee section
    guaranteeSection: {
      padding: '5rem 0',
      backgroundColor: '#ffffff',
      textAlign: 'center',
    },
    guaranteeTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '4rem',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
    },
    guaranteeSteps: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: '1200px',
      margin: '0 auto',
      gap: '2rem',
    },
    guaranteeStep: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
    },
    stepIcon: {
      width: '100px',
      height: '100px',
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2rem',
    },
    stepTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#2d5016',
    },
    
    // Numbers section
    numbersSection: {
      padding: '5rem 0',
      backgroundColor: '#f8fafc',
      textAlign: 'center',
    },
    numbersTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '1rem',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
    },
    numbersSubtitle: {
      fontSize: '2rem',
      color: '#b8860b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginBottom: '4rem',
    },
    numbersGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '4rem',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    numberCard: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    },
    numberIcon: {
      width: '100px',
      height: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '1rem',
    },
    numberIconImg: {
      width: '80px',
      height: '80px',
      objectFit: 'contain',
    },
    numberValue: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#d97706',
      marginBottom: '0.5rem',
    },
    numberLabel: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#2d5016',
      textAlign: 'center',
    },
    
    // Responsive styles
    '@media (max-width: 1024px)': {
      heroTitle: {
        fontSize: '3rem',
      },
      sectionTitle: {
        fontSize: '2.5rem',
      },
      farmsGrid: {
        gridTemplateColumns: '1fr',
        gap: '3rem',
        textAlign: 'center',
      },
      impactGrid: {
        gridTemplateColumns: '1fr',
        gap: '3rem',
      },
      guaranteeSteps: {
        flexDirection: 'column',
        gap: '3rem',
      },
      numbersGrid: {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '3rem',
      },
    },
    '@media (max-width: 768px)': {
      numbersGrid: {
        gridTemplateColumns: '1fr',
        gap: '2rem',
      },
    },
  };

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContainer}>
          <div style={styles.heroContent}>
            <div style={styles.heroLabel}>
              OUR
            </div>
            <h1 style={styles.heroTitle}>
              OFFERINGS
            </h1>
            <p style={styles.heroSubtitle}>
              At Siridharini, we offer you farmlands endowed with fertile soil perfect for growing high-profit 
              sandalwood trees, glorious views and splendid living.
            </p>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section style={styles.guaranteeSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.guaranteeTitle}>
            SIRIDHARINI'S GUARANTEE
          </h2>
          <div style={styles.guaranteeSteps}>
            <div style={styles.guaranteeStep}>
              <div style={styles.stepIcon}>
                <img src={require('../../assets/images/youbuy.png')} alt="You Buy" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <span style={styles.stepTitle}>You Buy</span>
            </div>
            <div style={styles.guaranteeStep}>
              <div style={styles.stepIcon}>
                <img src={require('../../assets/images/wegrow.png')} alt="We Grow" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <span style={styles.stepTitle}>We Grow</span>
            </div>
            <div style={styles.guaranteeStep}>
              <div style={styles.stepIcon}>
                <img src={require('../../assets/images/wecultivate.png')} alt="We Cultivate" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <span style={styles.stepTitle}>We Cultivate</span>
            </div>
            <div style={styles.guaranteeStep}>
              <div style={styles.stepIcon}>
                <img src={require('../../assets/images/wemanage.png')} alt="We Manage" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <span style={styles.stepTitle}>We Manage</span>
            </div>
            <div style={styles.guaranteeStep}>
              <div style={styles.stepIcon}>
                <img src={require('../../assets/images/youearn.png')} alt="You Earn" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <span style={styles.stepTitle}>You Earn</span>
            </div>
          </div>
        </div>
      </section>

      {/* Numbers Section */}
      <section style={styles.numbersSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.numbersTitle}>
            SIRIDHARINI
          </h2>
          <h3 style={styles.numbersSubtitle}>
            IN NUMBERS
          </h3>
          <div style={styles.numbersGrid}>
            <div style={styles.numberCard}>
              <div style={styles.numberIcon}>
                <img src={require('../../assets/images/18+acresofland.png')} alt="Acres of Land" style={styles.numberIconImg} />
              </div>
              <div style={styles.numberValue}>18+</div>
              <div style={styles.numberLabel}>Acres of Land</div>
            </div>
            <div style={styles.numberCard}>
              <div style={styles.numberIcon}>
                <img src={require('../../assets/images/farmplots.png')} alt="Farmplots" style={styles.numberIconImg} />
              </div>
              <div style={styles.numberValue}>50+</div>
              <div style={styles.numberLabel}>Farmplots</div>
            </div>
            <div style={styles.numberCard}>
              <div style={styles.numberIcon}>
                <img src={require('../../assets/images/trees.png')} alt="Trees" style={styles.numberIconImg} />
              </div>
              <div style={styles.numberValue}>18000</div>
              <div style={styles.numberLabel}>Trees</div>
            </div>
            <div style={styles.numberCard}>
              <div style={styles.numberIcon}>
                <img src={require('../../assets/images/jobscreated.png')} alt="Jobs Created" style={styles.numberIconImg} />
              </div>
              <div style={styles.numberValue}>120+</div>
              <div style={styles.numberLabel}>Jobs Created</div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Farms Section */}
      <section style={styles.ourFarmsSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.farmsGrid}>
            <div style={styles.farmsContent}>
              <h2>
                <span style={styles.sectionTitle}>OUR </span>
                <span style={styles.sectionSubtitle}>FARMS</span>
              </h2>
              <p style={styles.farmsDescription}>
                Chosen with the utmost care, the highlight of our farmlands is their rich soil which is 
                conducive to high crop yields. Worked using cutting edge scientific technology, 
                SiriDharini's farmlands give forth multi-billion cash crops without over exhausting the 
                earth.
              </p>
              <p style={styles.farmsDescription}>
                Our farms are home to Indian Sandalwood and Teak Wood trees, as well as fruit 
                plantations that provide additional income as well as fresh fruits for you to enjoy.
              </p>
              <button style={styles.visitButton} onClick={handleVisitFarms}>
                VISIT OUR FARMS
              </button>
            </div>
            <img 
              src="https://images.unsplash.com/photo-1625246333195-78d9c38ad449?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Modern farming equipment in field"
              style={styles.farmsImage}
            />
          </div>
        </div>
      </section>

      {/* Green Impact Section */}
      <section style={styles.greenImpactSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.impactGrid}>
            <img 
              src="https://images.unsplash.com/photo-1625246333195-78d9c38ad449?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Green wheat field with sun"
              style={styles.impactImage}
            />
            <div style={styles.impactContent}>
              <h2>
                <span style={styles.sectionTitle}>GREEN </span>
                <span style={styles.sectionSubtitle}>IMPACT</span>
              </h2>
              <p style={styles.impactDescription}>
                While giving you high returns on your investment, we never lose sight of our goal of 
                creating a positive environmental impact. We do this by restoring the vitality of dry 
                land, elevating soil quality, recharging groundwater levels, and reducing the amount 
                of atmospheric carbon. We truly believe our farmlands are a reflection of their 
                surroundings, and for that, we strive to improve and beautify the surrounding flora 
                and fauna
              </p>
              <button style={styles.visitButton} onClick={handleVisitFarms}>
                VISIT OUR FARMS
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm 
        pageSource="What We Offer Page"
        title="Get In Touch"
        onSubmitSuccess={(result) => {
          console.log('What We Offer page contact form submitted successfully:', result);
        }}
        onSubmitError={(error) => {
          console.error('What We Offer page contact form submission failed:', error);
        }}
      />

      {/* Map Section */}
      <section style={{
        padding: '60px 0',
        backgroundColor: 'white'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: '2rem',
            textAlign: 'center',
            marginBottom: '2rem',
            color: '#2d5016'
          }}>
            Our Farm Location
          </h2>
        </div>
        {/* Full-width map container */}
        <div style={{
          width: '100vw',
          position: 'relative',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          overflow: 'hidden'
        }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.0184872672107!2d77.65422287387703!3d12.620336053815237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae65e9bcb4a251%3A0x76b1620925218475!2sSiridharini!5e1!3m2!1sen!2sin!4v1784033535484!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{border: 0}}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Siridharini Farmlands - 615/1, Gopasandra, Deverabetta Road"
          ></iframe>
        </div>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            marginTop: '1rem',
            color: '#666'
          }}>
            📍 Siridharini Farmlands<br />
            615/1, Gopasandra, Deverabetta Road<br />
            Next to Reed Relays & Electronics, Thali Post Denkanekote
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WhatWeOfferPage;